import { useList } from 'effector-react';
import { FC, ReactNode } from 'react';
import { RegistryModel, Row } from 'shared/lib';
import { RegistryTableTrProps } from './registry-table-tr';

export type RegistryTableTrListProps<TRow extends Row> = Omit<RegistryTableTrProps, 'children'> & {
	children?: (row: TRow) => ReactNode;
	getProps?: (row: TRow) => RegistryTableTrProps;
};

export const createRegistryTableTrList = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
	TAdditionalData = unknown,
>(
	registryModel: RegistryModel<TRow, TFilters, TError, TAdditionalData>,
	RegistryTableTr: FC<RegistryTableTrProps>,
) => {
	const $rows = registryModel.$rows.map((rows) => rows ?? []);

	const RegistryTableTrList = ({ children, getProps, ...props }: RegistryTableTrListProps<TRow>) =>
		useList($rows, (row) => (
			<RegistryTableTr
				{...props}
				{...(getProps?.(row) ?? {})}
			>
				{children?.(row)}
			</RegistryTableTr>
		));

	return RegistryTableTrList;
};
